var angular = require('angular');
var debug = require('debug')('validation');

var VALID_CLASS = 'ng-valid';
var INVALID_CLASS = 'ng-invalid';
var PRISTINE_CLASS = 'ng-pristine';
var DIRTY_CLASS = 'ng-dirty';
var UNTOUCHED_CLASS = 'ng-untouched';
var TOUCHED_CLASS = 'ng-touched';


var module = angular.module("app.directives");

module.directive('showErrors', function(){
  return {
    restrict: 'A',
    require: '^form',
    template: '<div class="form-errors" ng-transclude></div>',
    transclude: true,
    replace: true,
    scope:  {
      $input: '=showErrors'
    },
    link: function(scope, element, attrs, form){
      var group = ['$input', '$input.$valid', '$input.$dirty', '$input.$touched'];
      scope.$watchGroup(group, function(){
        if (!scope.$input) return;
        var i = scope.$input;

        if (i.$dirty) {
          element.addClass(DIRTY_CLASS).removeClass(PRISTINE_CLASS);
        }
        if (i.$pristene) {
          element.addClass(PRISTINE_CLASS).removeClass(DIRTY_CLASS);
        }

        if (i.$valid) {
          element.addClass(VALID_CLASS).removeClass(INVALID_CLASS);
        }
        if (i.$invalid) {
          element.addClass(INVALID_CLASS).removeClass(VALID_CLASS);
        }

        if (i.$untouched) {
          element.addClass(UNTOUCHED_CLASS).removeClass(TOUCHED_CLASS);
        }
        if (i.$touched) {
          element.addClass(TOUCHED_CLASS).removeClass(UNTOUCHED_CLASS);
        }
      })
    }
  }
})
